// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_SIGNUP = "Registrace nov\u00e9ho \u010dlena";
export const SIGNUP_CONFIRM_AND_SIGN_UP = "Potvr\u010f a zaregistruj m\u011b.";
